import { render, staticRenderFns } from "./ArticlePreloader.vue?vue&type=template&id=d49b2ca6&scoped=true&"
var script = {}
import style0 from "./ArticlePreloader.vue?vue&type=style&index=0&id=d49b2ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49b2ca6",
  null
  
)

export default component.exports